import { useState, useEffect } from 'react';
import { appConfig } from '../config/AppConfig';

/**
 * Fetches this deployment's domain content from the backend (GET /domain/config),
 * which serves it from the domain pack (dashboards.json meta + ui.json). The UI
 * hardcodes NO domain content — sample questions and predefined goals come from here.
 *
 * To adapt to a new database, edit the pack — not this hook or the components.
 */
export function useDomainConfig(dbId) {
  const [config, setConfig] = useState({
    title: '',
    title_ar: '',
    subtitle: '',
    sampleQuestions: [],
    predefinedGoals: [],
    loading: true,
  });

  useEffect(() => {
    if (!dbId) return;
    let cancelled = false;

    (async () => {
      try {
        // appConfig.get() returns null until load() resolves; ensure config is ready
        // before reading the API URL (this hook runs on mount, racing the initial load).
        await appConfig.load();
        const apiUrl = appConfig.getMainApiUrl();
        const res = await fetch(`${apiUrl}/domain/config?db_id=${encodeURIComponent(dbId)}`);
        if (!res.ok) throw new Error(`domain/config ${res.status}`);
        const data = await res.json();
        if (cancelled) return;
        setConfig({
          title: data.title || '',
          title_ar: data.title_ar || '',
          subtitle: data.subtitle || '',
          sampleQuestions: data.sample_questions || [],
          predefinedGoals: data.predefined_goals || [],
          loading: false,
        });
      } catch (err) {
        console.error('Failed to load domain config:', err);
        if (!cancelled) {
          setConfig((c) => ({ ...c, loading: false }));
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dbId]);

  return config;
}
